import {
    ADDCHARGEMASTER_SUCCESS,
    ADDCHARGEMASTER_FAILED,
    RESET_ADDCHARGEMASTER,
    LOADING_ADDCHARGEMASTER,
    NETWORK_ERROR_ADDCHARGEMASTER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDCHARGEMASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDCHARGEMASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDCHARGEMASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADDCHARGEMASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDCHARGEMASTER:
            return (state = initialState);
        default:
            return state;
    }
};
